fragment PriceFull on Price {
  priceLevel
  taxLevel
  withoutTax
  withTax
}
